module.exports = __webpack_public_path__ + "media/images/sp/items/card/card_01-4cbdfec55c5aaaf9e09996740ccf7eaa.jpg";